import { render, staticRenderFns } from "./MasterGroupClassDetailsIncomeCard.vue?vue&type=template&id=30515630"
import script from "./MasterGroupClassDetailsIncomeCard.vue?vue&type=script&lang=js"
export * from "./MasterGroupClassDetailsIncomeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports